import gql from 'graphql-tag';

import { executeGqlMutation, type GqlCallVariables } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ActivateBrandTermsBatch($ids: [ID!]!) {
    activateBrandTermsBatch(ids: $ids)
  }
`;

interface Variables extends GqlCallVariables {
  ids: ID[];
}

export const activateBrandTermsBatch = async (
  variables: Variables
): Promise<boolean | undefined> => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });
  return getSingleProp<boolean>(result.data);
};
